import React       from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Chat        from '@shared/Chat'
import { pathname, getRequest, postRequest } from '@react/helpers/fetch'

const SupportChat = ({ ticketId, maxSizeMb, userName }) => {
  const showUrl     = pathname({ path: `/tickets/${ticketId}/support_chat`, format: 'json' })
  const messagesUrl = pathname({ path: `/tickets/${ticketId}/support_chat/messages`, format: 'json' })

  // The assistant holds the big card, so the reply box it feeds is not mounted:
  // the answer waits on the window and is claimed when going back remounts it.
  const useAnswer = text => {
    const detail = { recordType: 'Ticket', recordId: ticketId, text }
    window.ticketPendingAnswer = detail
    window.dispatchEvent(new CustomEvent('ticket:use-answer', { detail }))
    document.querySelector('[data-support-chat-back]')?.click()
  }

  const emptyState = (
    <>
      <div className="chat-empty-icon">
        <FontAwesomeIcon icon="comments" />
      </div>
      {I18n.t('chats.support_empty_hint')}
    </>
  )

  return (
    <div className="chat">
      <Chat
        key         = {ticketId}
        channel     = "SupportChatChannel"
        placeholder = {I18n.t('chats.support_placeholder')}
        onShow      = {() => getRequest(showUrl)}
        onMessages  = {body => postRequest({ url: messagesUrl, body })}
        onUseAnswer = {useAnswer}
        emptyState  = {emptyState}
        maxSizeMb   = {maxSizeMb}
        rows
        userName      = {userName}
        assistantName = {I18n.t('chats.assistant')}
        enterSends    = {false}
      />
    </div>
  )
}

export default SupportChat
